import { uniqueArray } from "@/utils";

function state() {
    return {
        recipes: [],
        tags: [],
        selectedTags: [],
        pagination: {
            current: null,
            last: null,
            total: null,
        },
        recipeDetail: {
            name: "",
        },
        recipeOthers: [],
        recipeProducts: [],
        globalLoading: false,
    };
}

const mutations = {
    SET_RECIPES(state, value) {
        state.recipes = value;
    },
    ADD_RECIPES(state, value) {
        value.forEach((recipe) => {
            state.recipes.push(recipe);
        });
    },
    SET_RECIPES_PAGINATION(state, { current, last, total }) {
        state.pagination = { current, last, total };
    },
    SET_RECIPES_TAGS(state, value) {
        state.tags = value;
    },
    SET_RECIPES_SELECTED_TAGS(state, value) {
        state.selectedTags = value;
    },
    SET_RECIPE_DETAIL(state, value) {
        state.recipeDetail = value;
    },
    CLEAR_RECIPE(state) {
        state.recipeDetail = {
            name: "",
        };
        state.recipeProducts = [];
        state.recipeOthers = [];
    },
    SET_RECIPE_OTHERS(state, value) {
        state.recipeOthers = value;
    },
    SET_PRODUCTS(state, value) {
        state.recipeProducts = value;
    },
    START_LOADING(state) {
        state.globalLoading = true;
    },
    STOP_LOADING(state) {
        state.globalLoading = false;
    },
};

const actions = {
    async getRecipes({ commit }, { query, isMore }) {
        commit("START_LOADING");
        return this.mikuApi.getRecipes(query).then((response) => {
            commit("SET_RECIPES_PAGINATION", {
                current: response.current_page,
                last: response.last_page,
                total: response.total,
            });
            const recipes = response.items.filter((i) => !i.media);

            if (isMore) {
                commit("ADD_RECIPES", recipes);
            } else {
                commit("SET_RECIPES", recipes);
            }
            commit("STOP_LOADING");
        });
    },
    async getRecipesTags({ commit }, query) {
        return this.mikuApi.getRecipesTags(query).then((response) => {
            const tags = response
                .map((tag) => tag.name)
                .filter(uniqueArray)
                .filter(Boolean);
            commit("SET_RECIPES_TAGS", tags);
            return tags;
        });
    },
    setRecipesTags({ commit }, tags) {
        commit("SET_RECIPES_SELECTED_TAGS", tags);
    },
    async getRecipeDetail({ commit }, slug) {
        commit("CLEAR_RECIPE");
        commit("START_LOADING");
        return this.mikuApi.getRecipeDetail(slug).then((response) => {
            commit("SET_RECIPE_DETAIL", response);
            commit("STOP_LOADING");
            return response;
        });
    },
    async getRecipeOthers({ commit }, query) {
        return this.mikuApi.getRecipes(query).then((response) => {
            commit("SET_RECIPE_OTHERS", response.items);
        });
    },
    async getRecipeProducts({ commit }, ids) {
        return this.mikuApi.getRecipeProducts(ids).then((response) => {
            commit("SET_PRODUCTS", response.items);
        });
    },
    async clearRecipe({ commit }) {
        commit("CLEAR_RECIPE");
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
